import * as React from 'react';
import {connect} from "react-redux";
import Utils from "../../../Utils";

interface Props {
    style?: any;
    totalCount: number;
    loadedCount: number;
    selectedCount: number;
    locale: {value: string, label: string};
}

class AgGridFooter extends React.Component<Props> {
    render(): React.ReactNode {
        return (
            <div style={{
                ...{
                    backgroundColor: "#2D3436",
                    color: "rgba(245, 245, 245, 0.64)",
                    width: "100%",
                    height: 25,
                    padding: 4,
                    border: "1px solid #424242",
                    borderTopWidth: 0,
                }, ...this.props.style
            }}>
                <span>
                    <span style={{fontSize: '1.2em', fontWeight: 600}}>Total: </span>
                    <span style={{fontSize: '1.2em', fontWeight: 600}}>{Utils.numberFormatByLocale(this.props.totalCount, this.props.locale.value)}</span>
                </span>
                {this.props.loadedCount !== undefined
                    ?
                    <span style={{marginLeft: 5}}>
                        <span style={{fontSize: '1.2em', fontWeight: 600}}>Loaded: </span>
                        <span style={{fontSize: '1.2em', fontWeight: 600}}>{Utils.numberFormatByLocale(this.props.loadedCount, this.props.locale.value)}</span>
                    </span>
                    : null
                }
                {this.props.selectedCount !== undefined
                    ?
                    <span style={{marginLeft: 5}}>
                        <span style={{fontSize: '1.2em', fontWeight: 600}}>Selected: </span>
                        <span style={{fontSize: '1.2em', fontWeight: 600}}>{Utils.numberFormatByLocale(this.props.selectedCount, this.props.locale.value)}</span>
                    </span>
                    :
                    null
                }
            </div>
        )
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        style: ownProps.style,
        totalCount: ownProps.totalCount,
        loadedCount: ownProps.loadedCount,
        selectedCount: ownProps.selectedCount,
        locale: state.auth.locale
    }
};

const mapDispatchToProps = () => {
    return {}
};

export default connect(mapStateToProps, mapDispatchToProps)(AgGridFooter)



// WEBPACK FOOTER //
// ./app/components/bo-core/common/AgGridFooter.tsx